<!--Add Body Specification Popup -->
<div style="padding: 0 !important;">
    <div class="body-spec-popup" (click)="$event.stopPropagation()">
        <details class="body-spec-form">
            <summary style="font-weight: 600;">{{setLabel("bodyCompositionAnalysisLabel")}}</summary>
            <div class="details-dropdown">
                <div>
                    <label>{{setLabel("totalBodyWaterLabel") || 'Total Body Water'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.totalBodyWater" pInputText />
                </div>
                <div>
                    <label>{{setLabel("proteinLabel") || 'Protein'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.protein" pInputText />
                </div>
                <div>
                    <label>{{setLabel("mineralLabel") || 'Mineral'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.mineral" pInputText />
                </div>
                <div>
                    <label>{{setLabel("bodyFatMassLabel") || 'Body Fat Mass'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.bodyFatMass" pInputText />
                </div>
                <div>
                    <label>{{setLabel("weightLabel") || 'Weight'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.weight" pInputText />
                </div>
            </div>
        </details>
        <details class="body-spec-form">
            <summary style="font-weight: 600;">{{setLabel("muscleFatAnalysisLabel")}}</summary>
            <div class="details-dropdown">
                <div>
                    <label>{{setLabel("weightLabel") || 'Weight'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.weight" pInputText />
                </div>
                <div>
                    <label>{{setLabel("sMMLabel") || 'SMM'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.sMM" pInputText />
                </div>
                <div>
                    <label>{{setLabel("bodyFatMassLabel") || 'Body Fat Mass'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.bodyFatMass" pInputText />
                </div>
                <div>
                    <label>{{setLabel("heightLabel") || 'Body Fat Mass'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.height" pInputText />
                </div>
            </div>
        </details>

        <details class="body-spec-form">
            <summary style="font-weight: 600;">{{setLabel("obesityAnalysisLabel")}}</summary>
            <div class="details-dropdown">
                <div>
                    <label>{{setLabel("bMILabel") || 'BMI'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.bMI" pInputText />
                </div>
                <div>
                    <label>{{setLabel("pBFLabel") || 'PBF'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.pBF" pInputText />
                </div>
            </div>
        </details>
        <details class="body-spec-form">
            <summary style="font-weight: 600;">{{setLabel("waistHipRatioLabel")}}</summary>
            <div class="details-dropdown">
                <div>
                    <label>{{setLabel("waistHipRatioLabel") || 'Waist-Hip Ratio'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.waistHipRatio" pInputText />
                </div>
            </div>
        </details>
        <details class="body-spec-form">
            <summary style="font-weight: 600;">{{setLabel("visceralFatLevelLabel")}}</summary>
            <div class="details-dropdown">
                <div>
                    <label>{{setLabel("visceralFatLevelLabel") || 'Visceral Fat Level'}}</label>
                    <input type="number" [(ngModel)]="bodySpec.visceralFatLevel" pInputText />
                </div>
            </div>
        </details>
        <div style="margin-top: 1em; text-align: right;">
            <button class="p-button p-button-success" pButton
                (click)="saveBodySpecification()">{{setLabel("saveBtnLabel") || 'Save'}}</button>
        </div>
    </div>
</div>